/**
 * Blog System TypeScript Interfaces
 */

export type AuthorSlug =
  | "technical-expert"
  | "friendly-guide"
  | "business-advisor"
  | "compliance-helper";

export type BlogCategory =
  | "getting-started"
  | "building-codes"
  | "permits"
  | "tools"
  | "tips"
  | "news";

export interface Author {
  slug: AuthorSlug;
  name: string;
  role: string;
  bio: string;
  avatar?: string;
  tone: string;
}

export interface BlogPost {
  slug: string;
  title: string;
  description: string;
  excerpt: string;
  content: string; // Markdown content
  author: AuthorSlug;
  category: BlogCategory;
  tags: string[];
  publishedAt: string; // ISO date string
  updatedAt?: string; // ISO date string
  readingTime: number; // minutes
  featuredImage?: string;
  tableOfContents: TableOfContentsItem[];
  relatedPosts?: string[]; // slugs
  callToAction?: CallToAction;
}

export interface TableOfContentsItem {
  id: string;
  title: string;
  level: 1 | 2 | 3;
}

export interface CallToAction {
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
}

export interface BlogMeta {
  totalPosts: number;
  categories: BlogCategory[];
  authors: AuthorSlug[];
  tags: string[];
}

// Helper type for blog post frontmatter
export interface BlogPostFrontmatter {
  title: string;
  description: string;
  author: AuthorSlug;
  category: BlogCategory;
  tags: string[];
  publishedAt: string;
  updatedAt?: string;
  featuredImage?: string;
  relatedPosts?: string[];
}

// Category display info
export const CATEGORY_INFO: Record<
  BlogCategory,
  { label: string; description: string }
> = {
  "getting-started": {
    label: "Getting Started",
    description: "Introduction to Builder Buddy and its features",
  },
  "building-codes": {
    label: "Building Codes",
    description: "Deep dives into NBC, NPC, NFC, and Calgary bylaws",
  },
  permits: {
    label: "Permits",
    description: "Calgary permit requirements and processes",
  },
  tools: {
    label: "Tools",
    description: "How to use our calculators and analysis tools",
  },
  tips: {
    label: "Tips & Tricks",
    description: "Expert advice for construction projects",
  },
  news: {
    label: "News",
    description: "Updates about Builder Buddy and industry news",
  },
};
